import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  getAdminPurchaseOpportunityOverview,
  getPurchaseOpportunity,
  getAllPurchaseOpportunities,
} from "../api/RequesTixApi";

export const purchaseOpportunity = createQueryKeys("purchaseOpportunity", {
  getAdminPurchaseOpportunityOverview: (purchaseOpportunityId: number | string) => ({
    queryKey: [purchaseOpportunityId, "overview"],
    queryFn: () => getAdminPurchaseOpportunityOverview(purchaseOpportunityId),
  }),
  getPurchaseOpportunity: (purchaseOpportunityId: number | string) => ({
    queryKey: [purchaseOpportunityId],
    queryFn: () => getPurchaseOpportunity(purchaseOpportunityId),
  }),
  getAllPurchaseOpportunities: (year: number) => ({
    queryKey: [year],
    queryFn: () => getAllPurchaseOpportunities(year),
  }),
});
